import $ from 'jquery';
import React from 'react';

class LogsPanel extends React.Component {
  constructor(props) {
    super(props);
    this.timeoutID = null;
    this.logs = null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.logs.length > prevProps.logs.length) {
      $('#logs').scrollTop($('#logs ul').height());
    }
  }

  /**
   * Method that is called after a timeout to revert the Copy Button to the initial state
   */
  clearCopytButtonTimeout = () => {
    $('.copyButton').text('Copy');
    $('.copyButton').removeClass('copied');
    clearTimeout(this.timeoutID);
  };

  /**
   * Method to copy logs into the clipboard
   */
  onCopy = () => {
    navigator.clipboard.writeText(this.logs);
    $('.copyButton').text('Copied');
    $('.copyButton').addClass('copied');
    this.timeoutID = setTimeout(this.clearCopytButtonTimeout, 1000);
  };

  render() {
    return (
      <div id="logsPanel">
        <span>{this.props.logs.length} events</span>
        <div id="logs">
          <ul>
            {(this.logs = '')}
            {this.props.logs.map((item, index) => {
              this.logs += item.time + ' ' + item.log + '\n';
              return (
                <li id={item.type + '_' + index} key={index}>
                  <span>{item.time}</span> {item.log}
                </li>
              );
            })}
          </ul>
        </div>
        <div className="buttons">
          <div className="copyButton" onClick={() => this.onCopy()}>
            Copy
          </div>
          <button
            type="button"
            className="btnGeneral secondaryBtn"
            onClick={() => this.props.onClear()}
          >
            Clear
          </button>
        </div>
      </div>
    );
  }
}

export default LogsPanel;
